import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css';
// Locals
import ar from 'vuetify/src/locale/ar';
import en from 'vuetify/src/locale/en';

import {
  VApp,
  VMain,
  VRow,
  VCol,
  VContainer,
  VBtn,
  VIcon,
  VTabs,
  VTab,
  VTabsItems,
  VTabItem,
  VImg,
  VForm,
  VTextField,
  VAutocomplete,
  VAlert,
  VInput,
  VDivider,
  VStepper,
  VStepperHeader,
  VStepperStep,
  VStepperItems,
  VStepperContent,
  VBreadcrumbs,
  VBreadcrumbsItem,
  VCheckbox,
  VCard,
  VSelect,
  VSkeletonLoader,
  VSpacer,
  VList,
  VMenu,
  VListItem,
  VListItemTitle,
  VDialog,
  VCardTitle,
  VCardText,
  VCardActions,
  VTextarea,
  VOtpInput,
} from 'vuetify/lib/components';

Vue.use(Vuetify, {
  components: {
    VApp,
    VMain,
    VRow,
    VCol,
    VContainer,
    VBtn,
    VIcon,
    VTabs,
    VTab,
    VTabsItems,
    VTabItem,
    VImg,
    VForm,
    VTextField,
    VAutocomplete,
    VAlert,
    VInput,
    VDivider,
    VStepper,
    VCheckbox,
    VStepperHeader,
    VStepperStep,
    VStepperItems,
    VStepperContent,
    VBreadcrumbs,
    VBreadcrumbsItem,
    VCard,
    VCardTitle,
    VSelect,
    VSkeletonLoader,
    VSpacer,
    VList,
    VMenu,
    VListItem,
    VListItemTitle,
    VDialog,
    VCardText,
    VCardActions,
    VTextarea,
    VOtpInput,
  },
});

export default new Vuetify({
  rtl: true,
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { ar, en },
    current: 'ar',
  },
  theme: {
    themes: {
      light: {
        primary: '#158E8D',
        secondary: '#e0cf97',
        lighterPrimary: '#36c5ba',
      },
    },
  },
});
